import { useEffect } from "react";
import { Container } from "../components/Container/Container";
import { CTASection } from "../components/CTASection/CTASection";
import { PageHeader } from "../components/PageHeader/PageHeader";
import { Section } from "../components/Section/Section";
import { ServiceCard } from "../components/ServiceCard/ServiceCard";
import { services } from "../content/site";
import { setPageMeta } from "../utils/metadata";
import * as styles from "./pages.css";

export function Services() {
  useEffect(() => {
    setPageMeta(
      "Services",
      "Explore Ayro Technologies services: consulting, audits and assessments, bespoke software solutions, and project management."
    );
  }, []);

  return (
    <>
      <PageHeader
        eyebrow="Services"
        title="Technical support across decisions, systems, software, and delivery."
        intro="Ayro brings practical consulting and engineering judgement to organisations that need clarity, execution, and dependable technical outcomes."
      />
      <Section>
        <Container>
          <div className={styles.gridTwo}>
            {services.map((service, index) => (
              <ServiceCard
                key={service.title}
                index={index + 1}
                title={service.title}
                summary={service.summary}
                details={service.details}
              />
            ))}
          </div>
        </Container>
      </Section>
      <Section tone="alt">
        <Container>
          <div className={styles.split}>
            <div>
              <h2 className={styles.sectionTitle}>Where we fit</h2>
              <p className={styles.mutedText}>
                We can support a focused review, lead a technical workstream, or provide
                the structure needed to move a difficult project forward.
              </p>
            </div>
            <ul className={styles.list}>
              <li className={styles.listItem}>
                Early-stage project shaping and technical discovery.
              </li>
              <li className={styles.listItem}>
                Independent assessment before a major decision or investment.
              </li>
              <li className={styles.listItem}>
                Bespoke tools and integrations when off-the-shelf software does not fit.
              </li>
              <li className={styles.listItem}>
                Delivery leadership when technical projects need clearer control.
              </li>
            </ul>
          </div>
        </Container>
      </Section>
      <CTASection />
    </>
  );
}
